import dateFormatsHelper from '$$helpers/dateFormatsHelper';

dateFormatsHelper.setUserDateFormat(user.dateFormat);
dateFormatsHelper.setUserTimeFormat(user.timeFormat);
dateFormatsHelper.setMomentLocale();

export default dateFormatsHelper;
